// extracted by mini-css-extract-plugin
export default {"paging":"index_paging_eOXIZ"};